/**
 * @generated SignedSource<<ce1a9123c5dc4e8c2e06b703c6275526>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UpdatesQuery$variables = {
  objectiveId?: string | null;
};
export type UpdatesQuery$data = {
  readonly viewer: {
    readonly " $fragmentSpreads": FragmentRefs<"UpdatesViewer">;
  };
};
export type UpdatesQuery = {
  response: UpdatesQuery$data;
  variables: UpdatesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "objectiveId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "kind": "Literal",
    "name": "last",
    "value": 50
  },
  {
    "kind": "Variable",
    "name": "outerObjectId",
    "variableName": "objectiveId"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v5 = {
  "alias": "assignee",
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "indirectObject",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastName",
      "storageKey": null
    },
    (v4/*: any*/)
  ],
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v7 = [
  (v3/*: any*/),
  (v1/*: any*/),
  (v6/*: any*/)
],
v8 = {
  "alias": "keyResult",
  "args": null,
  "concreteType": "KeyResult",
  "kind": "LinkedField",
  "name": "object",
  "plural": false,
  "selections": (v7/*: any*/),
  "storageKey": null
},
v9 = {
  "alias": "assigneeTeam",
  "args": null,
  "concreteType": "Team",
  "kind": "LinkedField",
  "name": "indirectObject",
  "plural": false,
  "selections": (v7/*: any*/),
  "storageKey": null
},
v10 = [
  (v8/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdatesQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "UpdatesViewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UpdatesQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": "updates",
            "args": (v2/*: any*/),
            "concreteType": "ActivityConnection",
            "kind": "LinkedField",
            "name": "activities",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ActivityEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "actor",
                        "plural": false,
                        "selections": [
                          (v1/*: any*/),
                          (v4/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "image",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "email",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "verb",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "createdAt",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cache",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "data",
                        "storageKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v5/*: any*/)
                        ],
                        "type": "ObjectiveAssignedActivity",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v5/*: any*/),
                          (v8/*: any*/)
                        ],
                        "type": "KeyResultAssignedActivity",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v9/*: any*/)
                        ],
                        "type": "ObjectiveAssignedTeamActivity",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v9/*: any*/),
                          (v8/*: any*/)
                        ],
                        "type": "KeyResultAssignedTeamActivity",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v10/*: any*/),
                        "type": "KeyResultStartValueChangeActivity",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v10/*: any*/),
                        "type": "KeyResultCurrentValueChangeActivity",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v10/*: any*/),
                        "type": "KeyResultTargetValueChangeActivity",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v10/*: any*/),
                        "type": "KeyResultDueDateChangeActivity",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v10/*: any*/),
                        "type": "KeyResultDeletedActivity",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v10/*: any*/),
                        "type": "KeyResultUpdatedActivity",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": "objective",
                            "args": null,
                            "concreteType": "Objective",
                            "kind": "LinkedField",
                            "name": "outerObject",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              (v6/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "url",
                                "storageKey": null
                              },
                              (v1/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "ObjectiveCreatedFloatingDescription",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v10/*: any*/),
                        "type": "KeyResultCreatedFloatingDescription",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "cursor",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endCursor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasNextPage",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasPreviousPage",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "startCursor",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": "updates",
            "args": (v2/*: any*/),
            "filters": [
              "outerObjectId"
            ],
            "handle": "connection",
            "key": "updates_updates",
            "kind": "LinkedHandle",
            "name": "activities"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "4ea4072e206affd2a70a05d2511677b4",
    "id": null,
    "metadata": {},
    "name": "UpdatesQuery",
    "operationKind": "query",
    "text": "query UpdatesQuery(\n  $objectiveId: ID\n) {\n  viewer {\n    ...UpdatesViewer\n    id\n  }\n}\n\nfragment UpdatesViewer on Viewer {\n  id\n  updates: activities(outerObjectId: $objectiveId, last: 50) {\n    edges {\n      node {\n        id\n        __typename\n        actor {\n          id\n          fullName\n          image\n          email\n        }\n        verb\n        createdAt\n        cache\n        data\n        ... on ObjectiveAssignedActivity {\n          assignee: indirectObject {\n            __typename\n            id\n            firstName\n            lastName\n            fullName\n          }\n        }\n        ... on KeyResultAssignedActivity {\n          assignee: indirectObject {\n            __typename\n            id\n            firstName\n            lastName\n            fullName\n          }\n          keyResult: object {\n            __typename\n            id\n            title\n          }\n        }\n        ... on ObjectiveAssignedTeamActivity {\n          assigneeTeam: indirectObject {\n            __typename\n            id\n            title\n          }\n        }\n        ... on KeyResultAssignedTeamActivity {\n          assigneeTeam: indirectObject {\n            __typename\n            id\n            title\n          }\n          keyResult: object {\n            __typename\n            id\n            title\n          }\n        }\n        ... on KeyResultStartValueChangeActivity {\n          keyResult: object {\n            __typename\n            id\n            title\n          }\n        }\n        ... on KeyResultCurrentValueChangeActivity {\n          keyResult: object {\n            __typename\n            id\n            title\n          }\n        }\n        ... on KeyResultTargetValueChangeActivity {\n          keyResult: object {\n            __typename\n            id\n            title\n          }\n        }\n        ... on KeyResultDueDateChangeActivity {\n          keyResult: object {\n            __typename\n            id\n            title\n          }\n        }\n        ... on KeyResultDeletedActivity {\n          keyResult: object {\n            __typename\n            id\n            title\n          }\n        }\n        ... on KeyResultUpdatedActivity {\n          keyResult: object {\n            __typename\n            id\n            title\n          }\n        }\n        ... on ObjectiveCreatedFloatingDescription {\n          objective: outerObject {\n            __typename\n            title\n            url\n            id\n          }\n        }\n        ... on KeyResultCreatedFloatingDescription {\n          keyResult: object {\n            __typename\n            id\n            title\n          }\n        }\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n      hasPreviousPage\n      startCursor\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "3d726b51444b1d16fe10792d8e4cb997";

export default node;
